/* eslint-disable */

/* ============
 * Russian Language File
 * ============
 */

export default {
  CONTENT: require("./content.json"),
  ERRORS: require("./errors.json"),
  NOTIFY: require("./notify.json"),
  VALIDATION_ERRORS: require("./validation.errors.json"),
};
